module.exports = __webpack_public_path__ + "img/head-shoulders_active.77c90d34.png";